import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { startWith, filter, pairwise, map, delay } from 'rxjs/operators';

/**
 * Replaces NbRestoreScrollTopHelper to process NavigationEnd events
 * asynchronously, ensuring ngAfterViewInit has completed before any
 * scroll position access (fixes "Cannot read properties of undefined
 * (reading 'nativeElement')" on NbLayoutComponent.getScrollPosition).
 */
@Injectable()
export class NbScrollTopPatchProvider {
  constructor(private router: Router) {}

  shouldRestore() {
    return this.router.events.pipe(
      startWith(null),
      filter(event => event === null || event instanceof NavigationEnd),
      pairwise(),
      map(([prev, current]: any[]) => this.pageChanged(prev, current)),
      filter(res => !!res),
      delay(0),
    );
  }

  private pageChanged(prev: any, current: any): boolean {
    const getPath = (url: string) => url.split('?')[0].split('#')[0];
    return !prev || getPath(prev.url) !== getPath(current.url);
  }
}
